export { belongsTo } from "@procision-software/mason";
